import { I_QREditorFormTemplate } from "@/data/types/pages";

import { getRuleErrorMessage, URLRegex } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrUrlStaticValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "qrUrlLink",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("qrUrlLink", "required", data),
        },
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("qrUrlLink", "pattern", data),
        },
      },
    },
  ];
};
